import React from "react";
import { useParams } from "react-router-dom";
import vehiclesData from "../../data/vehiclesData";
import VehicleOverviewSection from "../../components/sections/VehicleOverviewSection/VehicleOverviewSection";
import VehicleIntroBannerSection from "../../components/sections/VehicleIntroBannerSection/VehicleIntroBannerSection";
import VehicleFeatureSection from "../../components/sections/VehicleFeatureSection/VehicleFeatureSection";
import TechnologySection from "../../components/sections/TechnologySection/TechnologySection";
import InteriorsSection from "../../components/sections/InteriorSection/InteriorSection";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import VehicleSpecificationsSection from "../../components/sections/VehicleSpecifications/VehicleSpecificationsSection";

export default function VehicleDetailsPage() {
  const { vehicleId } = useParams();

  const vehicle =
    vehiclesData.find((v) => v.id === vehicleId) || vehiclesData[0];

  return (
    <>
      <VehicleOverviewSection vehicle={vehicle} />
      <VehicleIntroBannerSection vehicle={vehicle} />
      <VehicleFeatureSection vehicle={vehicle} />
      <TechnologySection vehicle={vehicle} />
      <InteriorsSection vehicle={vehicle} />
      <VehicleSpecificationsSection vehicle={vehicle} />
      <AftersalesSupportSection />
      {/* Later: specs section, interiors section, gallery, enquiry form, etc. */}
    </>
  );
}
